/** @format */
import {METHOD_NET30} from 'frontier-constants';
import {CheckboxWithErrorHandler} from 'frontier-form';
import {Alert} from '@sttark/design-system';
import React from 'react';

export const BillMeDirectly = props => {
    const {billingMethodId, isNet30Selected, handlePaymentMethodSelection} = props;

    return (
        <>
            {props.isNet30Approved && !props.isOverCreditLimit && !props.isOverPastDue && (
                <div
                    className={`payment-card mx-0 mt-3 ${
                        isNet30Selected && 'payment-card--selected'
                    }`}>
                    <label className="w-100 d-flex align-items-center justify-content-start m-0 payment-card_header">
                        <div
                            className={`shadow-input--radio ${
                                isNet30Selected && 'shadow-input-selected'
                            }`}></div>
                        <div
                            className="d-none"
                            onClick={() => handlePaymentMethodSelection(null, METHOD_NET30)}>
                            <CheckboxWithErrorHandler
                                value={billingMethodId == METHOD_NET30}
                                onChange={() => props.onChangeBillingMethod(true, null)}
                            />
                        </div>
                        <p className="font-body-md ms-3 me-0 my-0">
                            Bill Me Directly (Net 30 Terms)
                        </p>
                    </label>
                </div>
            )}
            {props.isOverCreditLimit && props.isNet30Approved && (
                <div className="mx-0 mt-3">
                    <Alert title="Your credit limit has been reached">
                        Please use a credit card to complete this order or contact us.
                    </Alert>
                </div>
            )}
            {props.isOverPastDue && props.isNet30Approved && (
                <div className="mx-0 mt-3">
                    <Alert title=" One or more invoices are over 15 days past due">
                        Please complete the invoice payment before continuing with this order or use
                        a credit card.
                    </Alert>
                </div>
            )}
        </>
    );
};
